// import React, { useEffect, useRef, useState } from "react";
// import Modal from "react-bootstrap/Modal";
// import { Form, Offcanvas } from "react-bootstrap";
// import Select from "react-select";
// import { Controller, useForm } from "react-hook-form";
// import Common_Back_Btn from "../../../../../common/common_components/common_back_btn/Common_Back_Btn";
// import Common_Form from "./Common_Form";

// import {
//   GetAll,
//   GetSingle,
//   Update,
// } from "../../../../../features/admin/role_permmission/owner/Slice";
// import { useDispatch } from "react-redux";

// const Edit_User = ({
//   show,
//   showError,
//   setShowError,
//   setShow,
//   setSuccess,
//   setErr,
//   handleClose
// }) => {
//   const dispatch = useDispatch();
//   const [defaultValues, setDefaultValues] = useState({});

//   const onSubmit = async (data) => {
//     try {

//       const sendData = new FormData();
//       sendData.append("role_id", 2);
//       sendData.append("name", data?.name);
//       sendData.append("contact_no", data?.contact_no);
//       sendData.append("email", data?.email);
//       sendData.append("user_name", data?.user_name);
//       sendData.append("address", data?.address);
//       sendData.append("aadhar_no", data?.aadhar_no);
//       sendData.append("password", data?.password);
//       if (data?.image) {
//         sendData.append("image", data?.image[0]);
//       }
//       const res = await dispatch(Update({ id: data.id, data: sendData }));

//       if (res.meta?.requestStatus === "fulfilled") {
//         dispatch(GetAll());
//         setShow(false);
//         setSuccess(true);
//       } else if (res.meta?.requestStatus === "rejected") {
//         console.log(
//           res.payload?.response?.data?.errors,
//           "res.payload?.response?.data?.errors"
//         );

//         setShowError(res.payload?.response?.data?.errors);
//       }
//     } catch (error) {
//       console.error(error);
//       setShow(false);
//       setErr(true);
//     }
//   };

//   const GetData = async (id) => {
//     try {
//       const res = await dispatch(GetSingle(id));
//       setDefaultValues(
//         res?.payload?.data
//       );
//     } catch (error) {
//       console.error(error);
//       setShow(false);
//       setErr(true);
//     }
//   };

//   useEffect(() => {
//     if (show) {
//       GetData(show);
//     }
//   }, [show]);
//   return (
//     <Offcanvas
//       className="mobile_offcanvas common_offcanvas"
//       show={show}
//       placement="end"
//       onHide={handleClose}
//       scroll={false}
//       backdrop={true}
//     >
//       <Offcanvas.Header>
//         <Offcanvas.Title>
//           <div className="back_div" onClick={handleClose}>
//             <Common_Back_Btn />
//           </div>
//           Edit Role
//         </Offcanvas.Title>
//       </Offcanvas.Header>
//       <Offcanvas.Body>
//         <div className="add_form">
//           <Common_Form handleClose={handleClose}/>
//         </div>
//       </Offcanvas.Body>
//     </Offcanvas>
//   );
// };

import React, { useEffect, useState } from "react";
import { Offcanvas } from "react-bootstrap";
import Common_Back_Btn from "../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Common_Form from "./Common_Form";
import { useDispatch } from "react-redux";
import {
  GetAll,
  GetSingle,
  Update,
} from "../../../../../features/admin/masters/method_of_testing/Slice";

const Edit_User = ({
  show,
  id, // pass the user id to edit
  setShow,
  setErr,
  handleClose,
  setSuccess,
}) => {
  const dispatch = useDispatch();
  const [defaultValues, setDefaultValues] = useState({});
  const [loading, setLoading] = useState(false);

  const [showError, setShowError] = useState({});
  const GetData = async (id) => {
    try {
      setLoading(true);
      const res = await dispatch(GetSingle(id));
      console.log("resresgot get single ", res);
      if (res.meta?.requestStatus === "fulfilled") {
        setDefaultValues({
          name: res?.payload?.data.name,
        });
      }
    } catch (error) {
      console.error(error);
      setErr(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (show) {
      GetData(id);
    }
  }, [show]);

  // Submit handler
  const onSubmit = async (data) => {
    try {
      const sendData = new FormData();

      sendData.append("name", data?.name);

      const res = await dispatch(Update({ id, data: sendData }));

      if (res.payload.success) {
        dispatch(GetAll());
        setTimeout(() => {
          setSuccess(false);
          handleClose();
        }, 1500);
        setShow(false);
        setSuccess(true);
      } else {
        setShowError(res.payload.errors);
      }
    } catch (error) {
      console.error(error);
      setErr(true);
    }
  };

  return (
    <Offcanvas
      className="mobile_offcanvas common_offcanvas"
      show={show}
      placement="end"
      onHide={handleClose}
      scroll={false}
      backdrop={true}
    >
      <Offcanvas.Header>
        <Offcanvas.Title>
          <div className="back_div" onClick={handleClose}>
            <Common_Back_Btn />
          </div>
          Edit Method Of Testing
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div className="add_form">
          {!loading && (
            <Common_Form
              handleClose={handleClose}
              onSubmit={onSubmit}
              defaultValues={defaultValues}
              showError={showError}
              success={false}
            />
          )}
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default Edit_User;
